import styled from 'styled-components';
import { popIn } from '../Animation';
import { paperTextureModal } from '../paperTexture';

export const ChangeModalFrame = styled.div<{ $isClosing: boolean }>`
  position: relative;
  padding: 20px;
  width: 440px;
  height: fit-content;

  opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
  transform: ${({ $isClosing }) => ($isClosing ? 'scale(0.8)' : 'scale(1)')};

  transition: all 0.3s ease-in;
  ${paperTextureModal}
  background-color: ${({ theme }) => theme.colors.color_Alpha_05};
  ${popIn}
`;
